module.exports = __webpack_public_path__ + "static/capr-608d1c08034a8d350bea0630dfc3466e.png";